var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineVector1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 361,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.927-90L237.409 146.126c-7.965 10.715-23.992 10.767-32.026.103l-70.446-93.505c-7.898-10.484-23.583-10.646-31.696-.327L-138 359.241",
    stroke: "#EEE",
    strokeWidth: 3
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDE1IiBoZWlnaHQ9IjM2MSIgdmlld0JveD0iMCAwIDQxNSAzNjEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00MTIuOTI3IC05MEwyMzcuNDA5IDE0Ni4xMjZDMjI5LjQ0NCAxNTYuODQxIDIxMy40MTcgMTU2Ljg5MyAyMDUuMzgzIDE0Ni4yMjlMMTM0LjkzNyA1Mi43MjM4QzEyNy4wMzkgNDIuMjM5OSAxMTEuMzU0IDQyLjA3ODMgMTAzLjI0MSA1Mi4zOTczTC0xMzggMzU5LjI0MSIgc3Ryb2tlPSIjRUVFRUVFIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+Cg==";
export { SvgLineVector1 as ReactComponent };